import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

class PromotionSummaryModal extends Component {

    render() {
        const {
            visible,
            onHide,
            onRequest,
            onCancel,
            targetAcademicSession,
            promotionCategory,
            eligibleStudents,
            totalSelectedStudents,
            currentYearData,
            targetYearData
        } = this.props;

        const eligibleCount = eligibleStudents?.length || 0;
        const totalCount = totalSelectedStudents || 0;

        // Dynamic data structure for current and target year
        const summaryData = [
            {
                year: 'Current Year',
                branch: currentYearData?.branchName || 'N/A',
                board: currentYearData?.boardName || 'N/A',
                grade: currentYearData?.className || 'N/A',
                section: currentYearData?.sectionName || 'N/A',
                studentCount: totalCount
            },
            {
                year: 'Target Year',
                branch: targetYearData?.branchName || 'N/A',
                board: targetYearData?.boardName || 'N/A',
                grade: targetYearData?.className || 'N/A',
                section: targetYearData?.sectionName || 'N/A',
                studentCount: eligibleCount
            }
        ];

        return (
            <Dialog
                // style={{ width: '90vw', maxWidth: '1000px', borderRadius: '16px', padding: 0, backgroundColor: 'red' }}
                visible={visible}
                modal
                // style={{ width: '90vw', maxWidth: '1000px', borderRadius: '16px', padding: 0 }}
                className="promotion-modal"
                onHide={onHide}
                header={null}
                closable={false}
                draggable={false}
                resizable={false}
                contentStyle={{ padding: 0 }}
                breakpoints={{ '960px': '90vw' }}
                 style={{ 
                    width: '90vw', 
                    maxWidth: '1000px', 
                    borderRadius: '16px', 
                    padding: 0,
                    overflow: 'hidden',
                    // backgroundColor: 'red'
                }}
            >
                <div style={{ position: 'relative', minHeight: 'auto' }}>
                    {/* Close Button */}
                    <button
                        onClick={onHide}
                        style={{
                            position: 'absolute',
                            top: 18,
                            right: 18,
                            background: 'transparent',
                            border: 'none',
                            fontSize: 22,
                            cursor: 'pointer',
                            zIndex: 2
                        }}
                        aria-label="Close"
                    >
                        &#10005;
                    </button>

                    <div className="flex flex-column align-items-center py-3 px-4" style={{ borderRadius: '', 
                    // backgroundColor: 'red'

                     }}>
                        {/* Success Icon */}
                        <div className="flex justify-content-center align-items-center" style={{ marginBottom: 12 }}>
                            <span style={{
                                background: "#D1FADF",
                                borderRadius: "50%",

                                padding: "16px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "64px",
                                height: "64px"
                            }}>
                                <span style={{ fontSize: 32 }}>
                                    <i className="fa fa-graduation-cap" />
                                </span>
                            </span>
                        </div>

                        <h3 className="font-bold text-center mb-3" style={{ fontSize: 22 }}>
                            Request Student Promotion
                        </h3>

                        {/* Target Academic Session and Promotion Category */}
                        <div className="grid w-full mb-3">
                            <div className="col-6 px-6">
                                <label className="font-semibold mb-1 block" style={{ fontSize: 15 }}>
                                    Target Academic Session :
                                </label>
                                <div style={{
                                    fontSize: 18,
                                    fontWeight: 'bold',
                                    color: '#333'
                                }}>
                                    {targetAcademicSession}
                                </div>
                            </div>
                            <div className="col-6 px-6">
                                <label className="font-semibold mb-1 block" style={{ fontSize: 15 }}>
                                    Target Promotion Category :
                                </label>
                                <div style={{
                                    fontSize: 18,
                                    fontWeight: 'bold',
                                    color: '#333'
                                }}>
                                    {promotionCategory || 'Financial Promotion'}
                                </div>
                            </div>
                        </div>

                        {/* Summary Table */}
                        <div className="w-full mb-3">
                            <DataTable
                                value={summaryData}
                                responsiveLayout="scroll"
                                showGridlines
                                className="dataTableValuesText"
                                style={{ fontSize: '14px' }}
                            >
                                <Column
                                    field="year"
                                    header="Year"
                                    style={{ width: "15%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                />
                                <Column
                                    field="branch"
                                    header="Branch"
                                    style={{ width: "15%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                />
                                <Column
                                    field="board"
                                    header="Board"
                                    style={{ width: "15%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                />
                                <Column
                                    field="grade"
                                    header="Grade"
                                    style={{ width: "15%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                />
                                <Column
                                    field="section"
                                    header="Section"
                                    style={{ width: "15%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                />
                                <Column
                                    field="studentCount"
                                    header="Student Count"
                                    style={{ width: "20%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                />
                            </DataTable>
                        </div>

                        {/* Total Count - Updated messaging */}
                        <div className="w-full mb-3">
                            <p style={{
                                fontSize: '16px',
                                textAlign: 'center',
                                margin: 0,
                                fontWeight: 'bold'
                            }}>
                                Total <span style={{ color: '' }}>{eligibleCount}</span> student(s) will be requested to promote for the next academic session
                            </p>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-content-center gap-3 mt-2">
                            <Button
                                label="Request"
                                className="p-button"
                                style={{
                                    background: "#2E90FA",
                                    borderRadius: "8px",
                                    padding: "10px 32px",
                                    fontWeight: 600,
                                    fontSize: 16,
                                    color: "#fff",
                                    border: "none"
                                }}
                                onClick={onRequest}
                            />
                            <Button
                                label="Cancel"
                                className="p-button-outlined"
                                style={{
                                    borderRadius: "8px",
                                    padding: "10px 32px",
                                    fontWeight: 600,
                                    fontSize: 16,
                                    border: "none",
                                    background: "#F2F4F7",
                                    color: "#344054"
                                }}
                                onClick={onCancel}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default PromotionSummaryModal;